import { useEffect, useState } from 'react';
import { fetchPreviousHandover } from '../lib/firestore';
import { getDb } from '../lib/firebase';

export interface PreviousHandover {
  handoverNotes: string;
  runId: string;
  runOrder: number;
}

/**
 * Resolves the previous run's handover note for a given (task, currentRun)
 * pair per addendum §5.
 */
export function usePreviousHandover(
  projectId: string | null,
  taskId: string | null,
  currentRunOrder: number | null,
): { data: PreviousHandover | null; loading: boolean } {
  const [data, setData] = useState<PreviousHandover | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!projectId || !taskId || currentRunOrder == null) {
        setData(null);
        return;
      }
      setLoading(true);
      try {
        const result = await fetchPreviousHandover(
          getDb(),
          projectId,
          taskId,
          currentRunOrder,
        );
        if (!cancelled) setData(result);
      } catch {
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    void run();
    return () => {
      cancelled = true;
    };
  }, [projectId, taskId, currentRunOrder]);

  return { data, loading };
}
